export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILE_ERR = "GET_PROFILE_ERR";
export const GET_APPEARANCE = "GET_APPEARANCE";
export const ADD_WISHLIST = "ADD_WISHLIST";
export const DELETE_WISHLIST = "DELETE_WISHLIST";
export const GET_WISHLIST_ITEMS = "GET_WISHLIST_ITEMS";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_PROFILE_ERR = "UPDATE_PROFILE_ERR";
export const GET_BLOGGER_PROFILE = "GET_BLOGGER_PROFILE";
export const GET_BLOGGER_PROFILE_ERR = "GET_BLOGGER_PROFILE_ERR";
export const GET_BLOGGER_APPEARANCE = "GET_BLOGGER_APPEARANCE"
export const PROFILE_CHECK = "PROFILE_CHECK"
// export const GET_CREDITCARDS = "GET_CREDITCARDS";
// export const UPDATE_PROFILE = "UPDATE_PROFILE";
// export const GET_NOTICE = "GET_NOTICE";
// export const UPDATE_NOTICE = "UPDATE_NOTICE";